export default __webpack_public_path__ + "static/slide08-be8c2b2d298c7a2e7c43b84d7de02ee4.png";